// IE polyfills
import "svgxuse";
import "core-js/stable";
import "regenerator-runtime/runtime";

import Tabs from "./tabs";
import addAccordion from "./accordion";
import {
  openSecondaryMenu,
  openMobileMenu,
  openProductsMobileMenu,
  openLanguagesMenu,
  openSupportMenu,
  openMobileSupportMenu,
} from "./menu-navigation";
import { calculateAll } from "./calculator";
import {
  businessesCarousel,
  feedbackCarousel,
  galleryCarousel,
} from "./sliders";
import {
  openInlineModal,
  openGalleryModal,
  openSliderGalleryModal,
} from "./modals";
import copyFormValues from "./contact-form";
import handleFormLabels from "./form-labels";
import handleFormErrors from "./form-errors";
import addSmoothScroll from "./smooth-scroll";
import triggerReadMore from "./read-more";
import initCookie from "./cookie";

initCookie();

const allTabContainers = document.querySelectorAll("[data-tabs]");

allTabContainers.forEach((el) => {
  const tab = new Tabs(el);
  tab.init();
});

if (window.location.hash) {
  document.querySelector(`a[href="${window.location.hash}"]`).click();
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 0);
}
(() => {
  const calculator = document.querySelector(".js-calc-price");
  if (!calculator) {
    return;
  }

  calculator.addEventListener(
    "click",
    (e) => {
      e.preventDefault();
      calculateAll();

      document.querySelector(".js-calc-results").classList.remove("u-hide");
    },
    false
  );
})();

// View all
(() => {
  const moreButtons = document.querySelectorAll(
    ".c-bordered-box__lined-list .show-more a"
  );
  moreButtons.forEach((button) => {
    button.addEventListener(
      "click",
      (e) => {
        e.preventDefault();
        button.parentNode.parentNode.classList.remove("partial");
        button.parentNode.parentNode.removeChild(button.parentNode);
      },
      false
    );
  });
})();

// Toggle Categories in support arhive sidebar
function toggleCat() {
  const toggleButtons = document.querySelectorAll(".js-toggle-category");
  if (!toggleButtons) {
    return;
  }
  toggleButtons.forEach((button) => {
    button.addEventListener(
      "click",
      (e) => {
        e.preventDefault();
        button.parentElement.nextElementSibling.classList.toggle("js-hidden");
        button.classList.toggle("is-open");
      },
      false
    );
  });
}

toggleCat();

// Color all parent gategories of active item in Help Center
(() => {
  function handleOpen(item) {
    item.classList.toggle("active-cat");
    item
      .querySelector(".cat-line")
      .querySelector("button")
      .classList.add("is-open");
    item.querySelector("ul").classList.remove("js-hidden");
  }

  if (document.querySelector(".c-bordered-box--support-category")) {
    if (document.querySelector(".active-item")) {
      const activeItem = document.querySelector(".active-item");
      let currentItem = activeItem;
      handleOpen(currentItem);
      while (
        !currentItem.parentElement.parentElement.classList.contains(
          "c-bordered-box__lined-list"
        )
      ) {
        currentItem = currentItem.parentElement;
        if (currentItem.tagName == "LI") {
          handleOpen(currentItem);
        }
      }
    }
  }
})();

// Toggle product categories in support-archive on mobile
(() => {
  const catToggleBtn = document.querySelectorAll(".js-product-cat-toggle");

  function catMenuToggle(menuCategories, toggleBtn) {
    menuCategories.classList.toggle("js-hidden");
    if (menuCategories.classList.contains("js-hidden")) {
      toggleBtn.style.marginBottom = "0";
      toggleBtn.querySelectorAll(".c-icon use").forEach((item) => {
        item.classList.toggle("u-hidden");
      });
    } else {
      toggleBtn.style.marginBottom = "20px";
      toggleBtn.querySelectorAll(".c-icon use").forEach((item) => {
        item.classList.toggle("u-hidden");
      });
    }
  }

  if (catToggleBtn && window.innerWidth < 1000) {
    catToggleBtn.forEach((btn) => {
      const menuCategories = btn.nextElementSibling;
      menuCategories.classList.add("js-hidden");
      btn.addEventListener("click", () => catMenuToggle(menuCategories, btn));
    });
  }
})();

// Toggle EAS logo
(() => {
  const easLogo = document.querySelector(".c-header-eas");
  const headerElement = document.querySelector("header");

  if (!easLogo) {
    return;
  }

  let headerHeight = headerElement.scrollHeight;

  document.addEventListener(
    "scroll",
    (e) => {
      if (window.scrollY + 200 > headerHeight) {
        easLogo.classList.add("is-hidden");
      } else {
        easLogo.classList.remove("is-hidden");
      }
    },
    false
  );
})();

openSecondaryMenu();
openMobileMenu();
openProductsMobileMenu();
openLanguagesMenu();
openSupportMenu();
openMobileSupportMenu();

addAccordion();

businessesCarousel();
feedbackCarousel();
galleryCarousel();

copyFormValues();

openInlineModal();
openGalleryModal();
openSliderGalleryModal();

handleFormLabels();
handleFormErrors();

addSmoothScroll();

triggerReadMore();
